module.exports = __webpack_public_path__ + "top_page/img-novelty-item@2x-ea8e5df4a2ecfeb289ebeaec066cea76.webp";